var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "observer", attrs: { tag: "form" } },
    [
      _c("layout-page", [
        _c(
          "div",
          { staticClass: "content-route-view" },
          [
            _c(
              "el-card",
              { staticClass: "card" },
              [
                !_vm.isEdicao
                  ? _c("h1", [_vm._v("Cadastro de usuário")])
                  : _c("h1", [_vm._v("Edição de usuário")]),
                _vm._v(" "),
                !_vm.isExterno
                  ? _c(
                      "el-row",
                      {
                        staticClass: "margin-top",
                        attrs: { type: "flex", justify: "start" }
                      },
                      [
                        !_vm.tipoChanged
                          ? _c(
                              "el-radio-group",
                              {
                                attrs: { disabled: _vm.isEdicao },
                                model: {
                                  value: _vm.setPessoaTipo,
                                  callback: function($$v) {
                                    _vm.setPessoaTipo = $$v
                                  },
                                  expression: "setPessoaTipo"
                                }
                              },
                              [
                                _c(
                                  "el-radio-button",
                                  { attrs: { label: "PF" } },
                                  [
                                    _c("i", { staticClass: "fal fa-user" }),
                                    _vm._v(" Pessoa Física\n          ")
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-radio-button",
                                  { attrs: { label: "PJ" } },
                                  [
                                    _c("i", { staticClass: "fal fa-building" }),
                                    _vm._v(" Pessoa Jurídica\n          ")
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isEdicao && !_vm.isExterno
                  ? _c("app-divider", { attrs: { label: "Dados do usuário" } })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isEdicao && !_vm.isExterno
                  ? _c(
                      "el-row",
                      { staticClass: "margin-top-15", attrs: { gutter: 30 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            !_vm.tipoChanged
                              ? _c("app-input-perfil", {
                                  attrs: { usuarioTipo: _vm.pessoa.tipo },
                                  on: {
                                    perfilAdicionado: _vm.perfilAdicionado
                                  },
                                  model: {
                                    value: _vm.usuario.perfis,
                                    callback: function($$v) {
                                      _vm.$set(_vm.usuario, "perfis", $$v)
                                    },
                                    expression: "usuario.perfis"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasTecnicoMunicipal
                              ? _c(
                                  "div",
                                  { staticClass: "margin-top-15" },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("app-label", {
                                                  attrs: {
                                                    label: "Prefeitura:"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass:
                                                      "full-width input",
                                                    class: {
                                                      erro: errors.length
                                                    },
                                                    model: {
                                                      value: _vm.idMunicipio,
                                                      callback: function($$v) {
                                                        _vm.idMunicipio = $$v
                                                      },
                                                      expression: "idMunicipio"
                                                    }
                                                  },
                                                  _vm._l(
                                                    _vm.municipios,
                                                    function(municipio) {
                                                      return _c("el-option", {
                                                        key: municipio.id,
                                                        attrs: {
                                                          label: municipio.nome,
                                                          value: municipio.id
                                                        }
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "help erro" },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1740030703
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isExterno && _vm.pessoa.tipo == "PF"
                          ? _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c("app-label", {
                                  attrs: { label: "Órgão:", required: false }
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "full-width input",
                                    attrs: { clearable: "" },
                                    model: {
                                      value: _vm.usuario.pessoa.orgao,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.usuario.pessoa,
                                          "orgao",
                                          $$v
                                        )
                                      },
                                      expression: "usuario.pessoa.orgao"
                                    }
                                  },
                                  _vm._l(_vm.orgaosOptions, function(orgao) {
                                    return _c("el-option", {
                                      key: orgao.id,
                                      attrs: {
                                        label: orgao.nome,
                                        value: orgao.id
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("app-divider", {
                      attrs: {
                        label:
                          _vm.pessoa.tipo == "PF"
                            ? "Pessoa Física"
                            : "Pessoa Jurídica"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.pessoa.tipo === "PF"
                  ? _c(
                      "el-row",
                      {
                        key: "pessoaFisica",
                        staticClass: "margin-top-15",
                        attrs: { gutter: 30, type: "flex" }
                      },
                      [
                        _c(
                          "el-col",
                          { staticClass: "boxInput", attrs: { span: 12 } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                mode: "lazy",
                                rules: "required|cpf_cnpj",
                                name: "cadastroUsuario/cpf"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("app-label", {
                                          attrs: {
                                            label: "CPF:",
                                            required: true
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          directives: [
                                            {
                                              name: "mask",
                                              rawName: "v-mask",
                                              value: ["###.###.###-##"],
                                              expression: "['###.###.###-##']"
                                            }
                                          ],
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: {
                                            disabled: _vm.isEdicao,
                                            type: "tel"
                                          },
                                          model: {
                                            value: _vm.pessoa.pessoaFisica.cpf,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.pessoa.pessoaFisica,
                                                "cpf",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "pessoa.pessoaFisica.cpf"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2657052775
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { staticClass: "boxInput", attrs: { span: 12 } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                mode: "lazy",
                                rules: "required",
                                name: "cadastroUsuario/nome"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("app-label", {
                                          attrs: {
                                            label: "Nome completo:",
                                            required: true
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: {
                                            maxlength: _vm.maxLengthNome
                                          },
                                          on: { blur: _vm.toUpperCase },
                                          model: {
                                            value: _vm.pessoa.pessoaFisica.nome,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.pessoa.pessoaFisica,
                                                "nome",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "pessoa.pessoaFisica.nome"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                3897500167
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "el-row",
                      {
                        key: "pessoaJuridica",
                        staticClass: "margin-top-15",
                        attrs: { gutter: 30, type: "flex" }
                      },
                      [
                        _c(
                          "el-col",
                          { staticClass: "boxInput", attrs: { span: 12 } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                mode: "lazy",
                                rules: "required|cpf_cnpj",
                                name: "cadastroUsuario/cnpj"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "CNPJ:",
                                          required: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "mask",
                                            rawName: "v-mask",
                                            value: ["##.###.###/####-##"],
                                            expression: "['##.###.###/####-##']"
                                          }
                                        ],
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        attrs: {
                                          disabled: _vm.isEdicao,
                                          "suffix-icon": "el-icon-search",
                                          type: "tel"
                                        },
                                        on: { blur: _vm.buscarDados },
                                        model: {
                                          value: _vm.pessoa.pessoaJuridica.cnpj,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pessoa.pessoaJuridica,
                                              "cnpj",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pessoa.pessoaJuridica.cnpj"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { staticClass: "boxInput", attrs: { span: 12 } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                mode: "lazy",
                                rules: "required",
                                name: "cadastroUsuario/razaoSocial"
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Razão Social:",
                                          required: true
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        attrs: {
                                          maxlength: _vm.maxLengthRazaoSocial
                                        },
                                        on: { blur: _vm.toUpperCase },
                                        model: {
                                          value:
                                            _vm.pessoa.pessoaJuridica
                                              .razaoSocial,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.pessoa.pessoaJuridica,
                                              "razaoSocial",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "pessoa.pessoaJuridica.razaoSocial"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    ]
                                  }
                                }
                              ])
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                _vm._v(" "),
                _vm.pessoa.tipo === "PJ"
                  ? _c(
                      "el-row",
                      { staticClass: "margin-top-15", attrs: { gutter: 30 } },
                      [
                        _c(
                          "el-col",
                          { staticClass: "boxInput", attrs: { span: 12 } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                mode: "lazy",
                                rules: "required",
                                name: "cadastroUsuario/nomeFantasia"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("app-label", {
                                          attrs: {
                                            label: "Nome fantasia:",
                                            required: true
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          on: { blur: _vm.toUpperCase },
                                          model: {
                                            value:
                                              _vm.pessoa.pessoaJuridica
                                                .nomeFantasia,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.pessoa.pessoaJuridica,
                                                "nomeFantasia",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "pessoa.pessoaJuridica.nomeFantasia"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2343095131
                              )
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { staticClass: "boxInput", attrs: { span: 12 } },
                          [
                            _c("validation-provider", {
                              attrs: {
                                mode: "lazy",
                                rules: "required",
                                name: "cadastroUsuario/inscricaoEstadual"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("app-label", {
                                          attrs: {
                                            label: "Inscrição estadual:",
                                            required: true
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          on: { blur: _vm.toUpperCase },
                                          model: {
                                            value:
                                              _vm.pessoa.pessoaJuridica
                                                .inscricaoEstadual,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.pessoa.pessoaJuridica,
                                                "inscricaoEstadual",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "pessoa.pessoaJuridica.inscricaoEstadual"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "help erro" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1911491293
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.pessoa.tipo === "PJ"
                  ? _c(
                      "el-row",
                      { staticClass: "margin-top-15", attrs: { gutter: 30 } },
                      [
                        _c(
                          "el-col",
                          { staticClass: "boxInput", attrs: { span: 12 } },
                          [
                            _c("app-label", {
                              attrs: {
                                label: "Código CNAE (subclasse):",
                                required: false
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: ["##.##-#/##"],
                                  expression: "['##.##-#/##']"
                                }
                              ],
                              staticClass: "input",
                              model: {
                                value: _vm.pessoa.pessoaJuridica.cnae.codigo,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.pessoa.pessoaJuridica.cnae,
                                    "codigo",
                                    $$v
                                  )
                                },
                                expression: "pessoa.pessoaJuridica.cnae.codigo"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { staticClass: "boxInput", attrs: { span: 12 } },
                          [
                            _c("app-label", {
                              attrs: {
                                label: "Nome da atividade conforme CNAE:",
                                required: false
                              }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "input",
                              on: { blur: _vm.toUpperCase },
                              model: {
                                value:
                                  _vm.pessoa.pessoaJuridica.cnae.nomeAtividade,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.pessoa.pessoaJuridica.cnae,
                                    "nomeAtividade",
                                    $$v
                                  )
                                },
                                expression:
                                  "pessoa.pessoaJuridica.cnae.nomeAtividade"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.pessoa.tipo === "PJ"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-row",
                          {
                            staticClass: "margin-top-15",
                            attrs: { gutter: 30 }
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "boxInput", attrs: { span: 12 } },
                              [
                                _c("app-label", {
                                  attrs: {
                                    label: "Ramo de atuação:",
                                    required: false
                                  }
                                }),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticClass: "input",
                                  on: { blur: _vm.toUpperCase },
                                  model: {
                                    value:
                                      _vm.pessoa.pessoaJuridica.ramoAtuacao,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.pessoa.pessoaJuridica,
                                        "ramoAtuacao",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "pessoa.pessoaJuridica.ramoAtuacao"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { staticClass: "boxInput", attrs: { span: 12 } },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    mode: "lazy",
                                    rules: "required|email",
                                    name: "cadastroUsuario/email"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("app-label", {
                                              attrs: {
                                                label: "E-mail:",
                                                required: true
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-input", {
                                              staticClass: "input",
                                              class: { erro: errors.length },
                                              attrs: {
                                                maxlength: _vm.maxLengthEmail
                                              },
                                              model: {
                                                value: _vm.pessoa.email,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.pessoa,
                                                    "email",
                                                    $$v
                                                  )
                                                },
                                                expression: "pessoa.email"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "help erro" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    407063553
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticClass: "margin-top-15",
                            attrs: { gutter: 30 }
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "boxInput", attrs: { span: 12 } },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    mode: "lazy",
                                    rules:
                                      "required|email_confirmation:@cadastroUsuario/email",
                                    name: "cadastroUsuario/emailConfirmacao"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("app-label", {
                                              attrs: {
                                                label: "Confirmar e-mail:",
                                                required: true
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("el-input", {
                                              staticClass: "input",
                                              class: { erro: errors.length },
                                              attrs: {
                                                maxlength: _vm.maxLengthEmail
                                              },
                                              model: {
                                                value: _vm.pessoa.confirmaEmail,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.pessoa,
                                                    "confirmaEmail",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "pessoa.confirmaEmail"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "help erro" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3402302899
                                  )
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { staticClass: "boxInput", attrs: { span: 12 } },
                              [
                                _c("app-input-telefone", {
                                  attrs: {
                                    telefones: _vm.usuario.pessoa.telefones,
                                    requiredTelefones: true,
                                    nomeAba: _vm.isEdicao
                                      ? "editUser"
                                      : "createUser",
                                    observer: this.$refs.observer
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "el-row",
                          {
                            staticClass: "margin-top-15",
                            attrs: { gutter: 30 }
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "boxInput", attrs: { span: 12 } },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    mode: "lazy",
                                    rules: "required|email",
                                    name: "cadastroUsuario/email"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "E-mail:",
                                              required: true
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              maxlength: _vm.maxLengthEmail
                                            },
                                            model: {
                                              value: _vm.pessoa.email,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pessoa,
                                                  "email",
                                                  $$v
                                                )
                                              },
                                              expression: "pessoa.email"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              { staticClass: "boxInput", attrs: { span: 12 } },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    mode: "lazy",
                                    rules:
                                      "required|email_confirmation:@cadastroUsuario/email",
                                    name: "cadastroUsuario/emailConfirmacao"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("app-label", {
                                            attrs: {
                                              label: "Confirmar e-mail:",
                                              required: true
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            attrs: {
                                              maxlength: _vm.maxLengthEmail
                                            },
                                            model: {
                                              value: _vm.pessoa.confirmaEmail,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.pessoa,
                                                  "confirmaEmail",
                                                  $$v
                                                )
                                              },
                                              expression: "pessoa.confirmaEmail"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-row",
                          {
                            staticClass: "margin-top-15",
                            attrs: { gutter: 30 }
                          },
                          [
                            _c(
                              "el-col",
                              { staticClass: "boxInput", attrs: { span: 12 } },
                              [
                                _c("app-input-telefone", {
                                  attrs: {
                                    telefones: _vm.usuario.pessoa.telefones,
                                    requiredTelefones: true,
                                    nomeAba: _vm.isEdicao
                                      ? "editUser"
                                      : "createUser",
                                    observer: this.$refs.observer
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                _vm._v(" "),
                _c("app-endereco", {
                  attrs: {
                    endereco: _vm.usuario.pessoa.enderecoCorrespondencia,
                    nomeAba: "cadastroUsuario",
                    disabledFields: _vm.disableEndereco,
                    upperCaseApply: true,
                    codigoEstado:
                      _vm.usuario.pessoa.enderecoCorrespondencia.municipio
                        .codigoEstado,
                    municipio:
                      _vm.usuario.pessoa.enderecoCorrespondencia.municipio
                  }
                }),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "margin-top footer",
                    attrs: { type: "flex", justify: "start" }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "cancelarButton",
                        on: { click: _vm.cancelar }
                      },
                      [
                        _c("i", { staticClass: "fas fa-times" }),
                        _vm._v(" Cancelar\n        ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.cadastrar()
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fas fa-check" }),
                        _vm._v(
                          " " +
                            _vm._s(!_vm.isEdicao ? "Cadastrar" : "Salvar") +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-967f2dfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-967f2dfe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/CadastroUsuario.vue
// module id = null
// module chunks = 